import React, { useState, useEffect } from "react";
import TotalNoCard from "../components/TotalNoCard/TotalNoCard";
import { HomeStyle } from "./Home.styled";
import PercentageCard from "../components/PercentageCard/PercentageCard";
import { toast } from "react-toastify";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getBaseStationCounts,
  getBeaconCounts,
  getTotalActiveAccount,
  getTotalBaseStation,
  getTotalBeacons,
  getTotalNoAcc,
} from "../api/HomeApi";
import { checkStatusExpiry } from "../common/checkStatusExpiry";
import { useDB } from "../context/DynamoDBContext";
import useInternetConnectivity from "../hooks/useInternetConnectivity";
import { useReload } from "../context/ReloadContext";
import StatusEnum from "../common/StatusEnum";
import Internet from "../components/internet/Internet";
import { useSelector } from "react-redux";
import ExportData from "../components/Export/ExportData";
import AccountCharts from "../components/accountCharts/AccountCharts";
import NoDataChart from "../components/NoDataChart/NoDataChart";
import { HeadingStyle } from "../styles/HeadingStyles";
import { PageStyle } from "../styles/MainBodyStyles";

const Home = () => {
  const { dynamoDBClient } = useDB();
  const { reload } = useReload();
  const queryClient = useQueryClient();
  const isOnline = useInternetConnectivity();
  const navigateRed = useSelector((state) => state.navigateRed);
  const [enableHomeAPIs, setEnableHomeAPIs] = useState(false);
  const [totalActiveBS, setTotalActiveBS] = useState(0);
  const [totalActiveB, setTotalActiveB] = useState(0);
  const [baseStationCounts, setBaseStationCounts] = useState({
    online: 0,
    offline: 0,
    snoozed: 0,
  });
  const [beaconCounts, setBeaconCounts] = useState({
    online: 0,
    offline: 0,
    snoozed: 0,
  });
  const [awsStatus, setAwsStatus] = useState("Offline");

  useEffect(() => {
    if (isOnline) {
      setAwsStatus("Online");
    } else {
      setAwsStatus("Offline");
    }
  }, [isOnline]);

  useEffect(() => {
    if (reload) {
      queryClient.fetchQuery(["TotalNoAcc"]);
      queryClient.fetchQuery(["TotalBaseStation"]);
      queryClient.fetchQuery(["TotalBeacons"]);
      queryClient.fetchQuery(["TotalActiveAcc"]);
      queryClient.fetchQuery(["baseStationCountDashboard"]);
      queryClient.fetchQuery(["beaconCountDashboard"]);
    }
  }, [reload]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (dynamoDBClient !== null) {
      setEnableHomeAPIs(true);
    } else {
      setEnableHomeAPIs(false);
    }
  }, [dynamoDBClient]);

  const handleError = (type) => {
    if (type === "TotalNoAcc") {
      toast.error("Unable to get Total Number of Accounts", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }

    if (type === "TotalBaseStation") {
      toast.error("Unable to get Total Number of Base Station", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }

    if (type === "TotalBeacons") {
      toast.error("Unable to get Total Number of Beacons", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }

    if (type === "TotalActiveAcc") {
      toast.error("Unable to get Total Number of Active Accounts", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
    if (type === "baseStationCountDashboard") {
      toast.error("Unable to get Total Number of Active Base Station", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
    if (type === "beaconCountDashboard") {
      toast.error("Unable to get Total Number of Active Beacons", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
  };

  const { status: TotalNoAccStatus, data: totalAcc } = useQuery({
    queryKey: ["TotalNoAcc"],
    queryFn: () => getTotalNoAcc(dynamoDBClient),
    enabled: enableHomeAPIs,
    onError: (error) => {
      console.log("TotalNoAcc :", error);
      handleError("TotalNoAcc");
    },
  });

  // if(TotalNoAccStatus === "error"){
  //   toast.error("Unable to get Total Number of Accounts",{
  //     bodyClassName:"notification-div-error",
  //     progressClassName:"progress-bar-error"
  //   })
  // }
  // if(TotalNoAccStatus === "error"){
  //   toast.error("Unable to get Total Number of Accounts",{
  //     bodyClassName:"notification-div-error",
  //     progressClassName:"progress-bar-error"
  //   })
  // }

  const { status: totalBaseStationStatus, data: totalBaseStation } = useQuery({
    queryKey: ["TotalBaseStation"],
    queryFn: () => getTotalBaseStation(dynamoDBClient),
    enabled: enableHomeAPIs,
    onError: (error) => {
      console.log("TotalBaseStation :", error);
      handleError("TotalBaseStation");
    },
  });

  // if(totalBaseStationStatus === "error"){
  //   toast.error("Unable to get Total Number of Base Station",{
  //       bodyClassName:"notification-div-error",
  //       progressClassName:"progress-bar-error"
  //   })
  // }
  // if(totalBaseStationStatus === "error"){
  //   toast.error("Unable to get Total Number of Base Station",{
  //       bodyClassName:"notification-div-error",
  //       progressClassName:"progress-bar-error"
  //   })
  // }

  const { status: totalBeaconsStatus, data: totalBeacons } = useQuery({
    queryKey: ["TotalBeacons"],
    queryFn: () => getTotalBeacons(dynamoDBClient),
    enabled: enableHomeAPIs,
    onError: (error) => {
      console.log("TotalBeacons :", error);
      handleError("TotalBeacons");
    },
  });

  // if(totalBeaconsStatus === "error"){
  //   toast.error("Unable to get Total Number of Beacons",{
  //       bodyClassName:"notification-div-error",
  //       progressClassName:"progress-bar-error"
  //   })
  // }
  // if(totalBeaconsStatus === "error"){
  //   toast.error("Unable to get Total Number of Beacons",{
  //       bodyClassName:"notification-div-error",
  //       progressClassName:"progress-bar-error"
  //   })
  // }

  const { status: totalActiveAccStatus, data: totalActiveAcc } = useQuery({
    queryKey: ["TotalActiveAcc"],
    queryFn: () => getTotalActiveAccount(dynamoDBClient),
    enabled: enableHomeAPIs,
    onError: (error) => {
      console.log("TotalActiveAcc :", error);
      handleError("TotalActiveAcc");
    },
  });

  // if(totalActiveAccStatus === "error"){
  //   toast.error("Unable to get Total Number of Active Accounts",{
  //       bodyClassName:"notification-div-error",
  //       progressClassName:"progress-bar-error"
  // if(totalActiveAccStatus === "error"){
  //   toast.error("Unable to get Total Number of Active Accounts",{
  //       bodyClassName:"notification-div-error",
  //       progressClassName:"progress-bar-error"

  //   })
  // }
  //   })
  // }

  const calculateBaseStation = (data = []) => {
    const baseStationStatusCounts = {
      online: 0,
      offline: 0,
      snoozed: 0,
    };
    setTotalActiveBS(data.length);
    if (data.length !== 0) {
      data.forEach((item) => {
        const bSStatus = item.Status;
        if (bSStatus === StatusEnum.online) {
          const isGreaterTime = checkStatusExpiry(item.DateUpdated);
          if (isGreaterTime) {
            baseStationStatusCounts[StatusEnum.offline]++;
          } else {
            baseStationStatusCounts[StatusEnum.online]++;
          }
        } else {
          baseStationStatusCounts[bSStatus]++;
        }
      });
      setBaseStationCounts(baseStationStatusCounts);
    } else {
      setBaseStationCounts(baseStationStatusCounts);
    }
  };

  const { data: baseStationCountData } = useQuery({
    queryKey: ["baseStationCountDashboard"],
    queryFn: () => getBaseStationCounts(dynamoDBClient),
    enabled: enableHomeAPIs,
    onSuccess: (data = []) => {
      calculateBaseStation(data);
    },
    onError: (error) => {
      console.log("baseStationCountDashboard :", error);
      handleError("baseStationCountDashboard");
    },
  });

  const calculateBeaconData = (data = []) => {
    setTotalActiveB(data.length);
    const beaconStatusCounts = {
      online: 0,
      offline: 0,
      snoozed: 0,
    };
    if (data.length !== 0) {
      data.forEach((item) => {
        const beaconStatus = item.BeaconStatus;
        if (beaconStatus === StatusEnum.online) {
          const isGreaterTime = checkStatusExpiry(item.DateUpdated);

          if (isGreaterTime) {
            beaconStatusCounts[StatusEnum.offline]++;
          } else {
            beaconStatusCounts[beaconStatus]++;
          }
        } else {
          beaconStatusCounts[beaconStatus]++;
        }
      });
      setBeaconCounts(beaconStatusCounts);
    }
  };

  const { data: beaconCountData } = useQuery({
    queryKey: ["beaconCountDashboard"],
    queryFn: () => getBeaconCounts(dynamoDBClient),
    enabled: enableHomeAPIs,
    onSuccess: (data = []) => {
      calculateBeaconData(data);
    },
    onError: (error) => {
      console.log("beaconCountDashboard :", error);
      handleError("beaconCountDashboard");
    },
  });

  useEffect(() => {
    if (baseStationCountData) {
      calculateBaseStation(baseStationCountData);
    }

    if (beaconCountData) {
      calculateBeaconData(beaconCountData);
    }
  }, []);

  return (
    <HomeStyle>
      <PageStyle>
        <ExportData />
        <div
          className={navigateRed.sideBar ? "home-container" : "home-container2"}
        >
          {!isOnline && <Internet />}
          <HeadingStyle>All Accounts</HeadingStyle>
          <div className="main">
            <TotalNoCard heading={"Total No of Accounts"} total={totalAcc} />
            <TotalNoCard
              heading={"Total No of Base Stations"}
              total={totalBaseStation}
            />
            <TotalNoCard heading={"Total No of Beacons"} total={totalBeacons} />
            <TotalNoCard
              heading={"Total No of Active Accounts"}
              total={totalActiveAcc}
            />
            <TotalNoCard
              heading={"Total No of Active Base Stations"}
              total={totalActiveBS}
            />
            <TotalNoCard
              heading={"Total No of Active Beacons"}
              total={totalActiveB}
            />
          </div>
          <HeadingStyle>
            All Devices & Platform&ensp;
            <i className="bi bi-boxes heading-icon"></i>
          </HeadingStyle>

          <div className="main2">
            {totalActiveBS !== 0 ? (
              <AccountCharts
                datasetIdKey={"baseStations"}
                data={baseStationCounts}
                module="Base Stations"
              />
            ) : (
              <NoDataChart datasetIdKey={"012@"} module="Base Stations" />
            )}
            {totalActiveB !== 0 ? (
              <AccountCharts
                datasetIdKey={"beacon"}
                data={beaconCounts}
                module="Beacons"
              />
            ) : (
              <NoDataChart datasetIdKey={"345$"} module="Beacons" />
            )}
          </div>
          <div className="main">
            <PercentageCard
              heading={"Total No of Active Base Stations Reporting Online"}
              total={baseStationCounts.online}
            />
            <PercentageCard
              heading={"Total No of Active Beacon Reporting Online"}
              total={beaconCounts.online}
            />
            <PercentageCard
              heading={"Total No of Active Base Stations Reporting Offline"}
              total={baseStationCounts.offline}
            />
            <PercentageCard
              heading={"Total No of Active Beacon Reporting Offline"}
              total={beaconCounts.offline}
            />
            <PercentageCard
              heading={"Total No of Active Base Stations Reporting Snooze"}
              total={baseStationCounts.snoozed}
            />
            <PercentageCard
              heading={"Total No of Active Beacon Reporting Snooze"}
              total={beaconCounts.snoozed}
            />
            <PercentageCard heading={"AWS Current Status"} total={awsStatus} />
          </div>
        </div>
      </PageStyle>
    </HomeStyle>
  );
};

export default Home;
